import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=d8f33f4e&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f33f4e')) {
      api.createRecord('d8f33f4e', component.options)
    } else {
      api.reload('d8f33f4e', component.options)
    }
    module.hot.accept("./Confirmation.vue?vue&type=template&id=d8f33f4e&", function () {
      api.rerender('d8f33f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/AdditionalResources/Confirmation.vue"
export default component.exports